import React from 'react';
import { useTheme } from '@emotion/react';
import { type RestExperience } from '@bbkAdminUtils/api-client/rest-experiences-api';
import { cs } from '@bbkAdminUtils/css-utils';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';

type Props = {
  funnel?: {
    layout: Pick<RestExperience['layout'], 'name' | 'template' | 'version'>;
  };
  containerClassName?: string;
  isPricingPage?: boolean;
};
const Container: ReactFCC<Props> = ({
  funnel,
  containerClassName,
  isPricingPage = false,
  children,
}) => {
  const theme = useTheme() as EmotionTheme;

  if (!funnel) return null;

  const {
    layout: { name, template, version },
  } = funnel;

  if (isPricingPage) {
    return <>{children}</>;
  }

  return (
    <div
      className={cs('exit-survey', containerClassName)}
      css={{ background: theme.background }}
    >
      <div
        className={cs(name, 'exit-funnel', containerClassName)}
        data-template={template}
        data-version={version}
        css={{
          fontFamily: theme.fontFamily,
          fontSize: theme.fontSize,
          fontWeight: theme.fontWeight,
          color: theme.textColor,
          background: theme.background,
        }}
      >
        <div className={containerClassName}>{children}</div>
      </div>
    </div>
  );
};

export default Container;
